import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

const PrivateRoute = ({
  component: Component,
  acceptAgreement,
  authed,
  registered,
  path,
  ...rest
}) => {
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const hasCurrentUser = !!Object.keys(currentUser).length;
  const isAccountTbAdmin = hasCurrentUser
    && (process.env.TB_ADMINS?.split(',') ?? []).includes(`${currentUser.id}`);
  const billingRedirectRequired = hasCurrentUser
    && !isAccountTbAdmin
    && currentUser.admin > 0
    && ['EXPIRED', 'TRIAL_ENDED'].includes(currentUser.organizationSubscriptionStatus);

  return (
    <Route
      {...rest}
      render={
        (props) => {
          if (authed && registered) {
            if (!acceptAgreement && path !== '/accept-agreement') {
              return <Redirect to='/accept-agreement' />;
            }
            if (billingRedirectRequired && path !== '/settings/cancel') {
              window.location.href = `${process.env.PHP_APP_URL || 'https://app.teambuildr.com'}/billing`;
              return null;
            }
            return <Component {...props} />;
          }

          if (!registered) {
            return <Redirect to='/signup/registration' />;
          }

          const currentQueryString = window.location.search;
          const existingParams = new URLSearchParams(currentQueryString);
          const newParams = new URLSearchParams();
          newParams.set('rel', path.replace('/', ''));
          newParams.set('version', '2');
          existingParams.forEach((value, key) => {
            if (key !== 'rel' && key !== 'version') {
              newParams.set(key, value);
            }
          });

          let domain;
          if (process.env.WEBAPP_URL) {
            domain = process.env.WEBAPP_URL;
          } else {
            const isDevelop = process.env.ENVIRONMENT === 'DEVELOP' ? 'dev.app-v3' : 'app.';
            domain = `https://${process.env.ENVIRONMENT === 'STAGING' ? 'staging.app-v3.' : isDevelop}teambuildr.com`;
          }

          window.location.href = `${domain}/login?${newParams.toString()}`;
          return null;
        }
      }
    />
  );
};

PrivateRoute.propTypes = {
  acceptAgreement: PropTypes.bool.isRequired,
  authed: PropTypes.bool.isRequired,
  component: PropTypes.elementType.isRequired,
  path: PropTypes.string.isRequired,
  registered: PropTypes.bool.isRequired,
};

export default PrivateRoute;
